import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { Note } from '../../../core/data';
import { markAsTouched } from '../../utils';
import { requiredValidator } from '../../validators';
import { UploadModalComponent } from './upload-modal.component';

@Component({
  selector: 'app-note-form',
  templateUrl: './note-form.component.html',
})
export class NoteFormComponent {
  attachments = [];
  errors: string[];
  form = new FormGroup({
    contents: new FormControl(null, requiredValidator()),
  });

  @Input() disabled = false;
  @Input() visible = false;
  @Input() showVisibility = false;
  @Input() canAttach = true;
  @Input() canSubmit = true;
  @Output() submitted = new EventEmitter<Note>();
  @ViewChild(UploadModalComponent) uploadModal;

  upload(files: FileList) {
    this.errors = null;
    const items = Array.from(files);

    // Ensure files aess than 10mb
    if (Array.from(files).some(file => file.size >= 10485760)) {
      this.errors = ['Documents may not be greater than 10 MB.'];
    } else if (items.length) {
      this.uploadModal.open(items);
    }
  }

  uploaded(attachments) {
    this.attachments = [...this.attachments, ...attachments];
  }

  submit() {
    if (this.form.valid) {
      this.submitted.emit({
        ...this.form.value,
        attachments: this.attachments,
        visible: this.visible,
      });
      this.reset();
    } else {
      markAsTouched(this.form);
    }
  }

  reset() {
    this.attachments = [];
    this.form.reset();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/notes/note-form.component.ts